import {
  appsWorkordersApiListWorkOrders,
  getAppsWorkordersApiListWorkOrdersQueryKey,
} from '@/lib/api/generated/endpoints'
import type { AppsWorkordersApiListWorkOrdersParams } from '@/lib/api/generated/types.ts/appsWorkordersApiListWorkOrdersParams'
import type { PaginatedWorkOrders } from '@/lib/api/generated/types.ts/paginatedWorkOrders'
import { queryOptions } from '@tanstack/react-query'

/** Page size of the global «Наряди» list (route loader and page share it). */
export const WO_GLOBAL_LIST_LIMIT = 500

/**
 * Read-only paginated work orders list.
 *
 * Backend contract (apps/workorders/api.py):
 *  - `GET /api/work-orders?project_id=&work_order_type=&status=&limit=&offset=` →
 *    `{ items: WorkOrderOut[], total, limit, offset }`
 *
 * NOTE: filter param names are snake_case on the wire (`work_order_type`,
 * not `type`). The route's URL search keys use the short `type` form for
 * cleaner URLs; the page-level translator maps URL ↔ API params.
 *
 * `staleTime: 15s` — same cadence as the transactions ledger; WO list also
 * mutates from "create / issue / post / cancel" actions in W4.
 */
export const workOrdersListQuery = (params: AppsWorkordersApiListWorkOrdersParams) =>
  queryOptions({
    queryKey: getAppsWorkordersApiListWorkOrdersQueryKey(params),
    queryFn: async ({ signal }) =>
      (await appsWorkordersApiListWorkOrders(params, {
        signal,
      })) as unknown as PaginatedWorkOrders,
    staleTime: 15_000,
  })
